import { render, staticRenderFns } from "./RevenueGraphComponent.vue?vue&type=template&id=4d274236&scoped=true"
import script from "./RevenueGraphComponent.vue?vue&type=script&lang=js"
export * from "./RevenueGraphComponent.vue?vue&type=script&lang=js"
import style0 from "./RevenueGraphComponent.vue?vue&type=style&index=0&id=4d274236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d274236",
  null
  
)

export default component.exports